import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Infraction} from "../domain/infraction";
import {Page} from "../domain/page";
import {Response, URLSearchParams} from "@angular/http";
import {InfractionState} from "../domain/infractionState";
import {InfractionType} from "../domain/infractionType";

@Injectable()
export class InfractionsService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findInfractions(filter: Infraction, page: number, itemsPerPage: number): Observable<Page> {
        return this.backendService.get("infractions", InfractionsService.setParams(filter, page, itemsPerPage));
    }

    public downloadFilterInfractions(filter: Infraction, page: number, itemsPerPage: number, withActs: boolean): Observable<Response> {
        return this.backendService.getAttachment("/infractionsReport?", InfractionsService.setParams(filter, page, itemsPerPage, withActs));
    }

    public static getURLFilterInfractions(filter: Infraction, page: number, itemsPerPage: number, withActs: boolean): string {
        return "/infractionsReport?" + InfractionsService.setParams(filter, page, itemsPerPage, withActs).toString();
    }

    public static getURLInfractionBulkload(documentId: string): string {
        return "/infractionsBulkloadDocument/" + documentId;
    }

    public persistUpdateInfractionDocuments(): Observable<any> {
        return this.backendService.get("persistUpdateInfractionDocuments", null);
    }

    public downloadFilterInfractionsForIE(filter: Infraction, page: number, itemsPerPage: number, withActs: boolean): string {
        return window.location.origin + '/infractionsReport?' + InfractionsService.setParams(filter, page, itemsPerPage, withActs).toString();
    }

    private static setParams(filter: Infraction, page: number, itemsPerPage: number, withActs?: boolean): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.vehicle && filter.actNumber) {
            params.set('actNumber', filter.actNumber);
        }
        if (filter.vehicle && filter.vehicle.patent) {
            params.set('vehicle.patent', filter.vehicle.patent);
        }
        if (filter.vehicle && filter.vehicle.contract.bank && filter.vehicle.contract.bank.id !== '') {
            params.set('vehicle.contract.bank.id', filter.vehicle.contract.bank.id);
        }
        if (filter.vehicle && filter.vehicle.contract.contractNumber) {
            params.set('vehicle.contract.contractNumber', filter.vehicle.contract.contractNumber);
        }
        if (filter.vehicle && filter.vehicle.contract.cuit) {
            params.set('vehicle.contract.cuit', filter.vehicle.contract.cuit);
        }
        if (filter.address && filter.address.city && filter.address.city.id) {
            params.set('address.city.id', filter.address.city.id);
        }
        if (filter.creationDateSince && filter.creationDateUntil) {
            params.set('creationDateSince', filter.creationDateSince);
            params.set('creationDateUntil', filter.creationDateUntil);
        }
        if (filter.state.id !== '') {
            params.set('state.id', filter.state.id);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));

        /*Opcional: descarga de imágenes de actas*/
        params.set('withActs', String(withActs));
        return params;
    }

    public save(infraction: Infraction): Observable<Infraction> {
        if (infraction.id != null) {
            return this.backendService.post("infraction", infraction, null);
        } else {
            return this.backendService.put("infraction", infraction, null);
        }
    }

    public delete(id: string): Observable<Infraction> {
        return this.backendService.delete("infraction/" + id, null, null);
    }

    public getInfraction(id: string): Observable<Infraction> {
        return this.backendService.get("infraction/" + id, null);
    }

    public getInfractionStates(): Observable<InfractionState[]> {
        return this.backendService.get("infractionStates", null);
    }

    public getInfractionTypes(): Observable<InfractionType[]> {
        return this.backendService.get("infractionTypes", null);
    }

    public generateInfractionTempId(): Observable<any> {
        return this.backendService.get("infraction/generateTempId", null);
    }

    public deleteTempInfractionDocument(infractionId: string, documentType: string): Observable<boolean> {
        return this.backendService.delete("infraction/" + infractionId + "/documentTemp/" + documentType, null, null);
    }

    public sendMail(infraction: Infraction): Observable<Infraction> {
        return this.backendService.post("infraction/sendMail", infraction, null);
    }

    public getInfractionByActNumberAndState(actNumber: string, stateId: string): Observable<Infraction> {
        return this.backendService.get("infraction/" + actNumber + "/" + stateId, null);
    }

    /**
     * MIGRACION
     */
    public migrateActs(): Observable<Boolean> {
        return this.backendService.post("infraction/migration", null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/infractions.service.ts
 **/